import { booleanAttribute, ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { Tracked } from '@/utils/signals/tracked';

enum ListType {
  TGA = 'TGA',
  POI = 'POI',
}

@Component({
  standalone: false,
  selector: 'wr-building-scan-poi-navigator',
  templateUrl: './building-scan-poi-navigator.component.html',
  styleUrls: ['./building-scan-poi-navigator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuildingScanPoiNavigatorComponent {
  readonly ListType = ListType;
  readonly selectedList = signal<ListType>(ListType.TGA);

  @Tracked()
  @Input()
  scanId: string = '';

  @Input({ transform: booleanAttribute })
  readonly = false;
}
